import { useState, useRef } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Box,
  Typography,
} from '@mui/material';

import { DataLoading, Button as CustomButton } from '../common';
import colors from '../../assets/colors';
import { loan } from '../../utils/api';

const IncomeFileUploadDialog = ({
  open,
  handleAction,
  incomeID,
  incomeType,
  loanID,
  removalIndex,
  handleArray,
}) => {
  const hiddenFileInput = useRef(null);
  const [errorText, setErrorText] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [successful, setSuccessful] = useState(true);

  const handleUpload = () => {
    setSuccessful(true);
    handleArray(removalIndex, incomeType);
    setIsUploading(false);
    handleAction(false);
  };

  const handleClose = () => {
    handleAction(false);
    setSuccessful(true);
  };

  const handleInputClick = (event) => {
    hiddenFileInput.current.click();
  };

  const onChangeHandler = async (event) => {
    await uploadFile(event.target.files[0]);
  };

  const uploadFile = (fileup) => {
    setIsUploading(true);
    const data = new FormData();
    data.append('file', fileup);
    data.append('id', incomeID);
    let type = '';
    switch (incomeType) {
      case 'additional':
        type = 'additional-income';
        break;
      case 'animal':
        type = 'animal-production';
        break;
      case 'liability':
        type = 'financial-liability';
        break;
      default:
        break;
    }
    loan
      .confirmIncome(loanID, type, incomeID, data)
      .then((result) => {
        if (result.status === 200) {
          setIsUploading(false);
          handleUpload();
        }
      })
      .catch(() => {
        setIsUploading(false);
        setSuccessful(false);
        setErrorText('Coś poszło nie tak, spróbuj ponownie później!');
      });
  };

  return (
    <Dialog
      PaperProps={{
        style: {
          backgroundColor: colors.white,
          color: colors.oldAgroweGreen,
          width: '65%',
        },
      }}
      open={open}
    >
      <DialogTitle align="center" sx={{ p: 2, mt: 1 }}>
        Dodaj potwierdzenie dochodu/obciążenia
      </DialogTitle>
      <DialogContent>
        {isUploading ? (
          <DataLoading />
        ) : successful ? (
          <Box component="div" sx={{ marginTop: 1 }}>
            <CustomButton
              type="submit"
              variant="contained"
              fullWidth
              onClick={handleInputClick}
            >
              Umieść plik potwierdzający
            </CustomButton>
            <input
              ref={hiddenFileInput}
              style={{ display: 'none' }}
              id="file"
              type="file"
              name="file"
              onChange={onChangeHandler}
              aria-label="fileInput"
            />
          </Box>
        ) : (
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            sx={{ textAlign: 'center', marginBottom: '8%' }}
          >
            <Typography variant={'h5'} sx={{ color: colors.redError }}>
              {errorText}
            </Typography>
          </Grid>
        )}
        <CustomButton variant="contained" fullWidth onClick={handleClose}>
          Zamknij okno
        </CustomButton>
      </DialogContent>
    </Dialog>
  );
};

export default IncomeFileUploadDialog;
